// src/hooks/useCompatibility.js
import { useMemo } from 'react';
import { getAllComponents } from '../data/aiOntology';
import { getCompatibleComponents, checkCompatibility } from '../data/compatibility';

export const useCompatibility = (selectedComponents) => {
  const allComponents = useMemo(() => getAllComponents(), []);
  
  const compatibleComponents = useMemo(() => {
    return getCompatibleComponents(selectedComponents, allComponents);
  }, [selectedComponents, allComponents]);
  
  const getScore = (component) => {
    if (selectedComponents.length === 0) return 100;
    
    let score = 0;
    let totalWeight = 0;
    
    for (const sc of selectedComponents) {
      const weight = 1;
      totalWeight += weight;
      
      if (checkCompatibility(component, sc)) {
        score += weight;
      }
    }
    
    return Math.round((score / totalWeight) * 100);
  };
  
  return {
    allComponents,
    compatibleComponents,
    getScore
  };
};